export function ResourceRoomProjectHeader({
  projectId,
  eyebrow,
  title,
  description,
  actions
}: {
  projectId: string;
  eyebrow: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}): React.JSX.Element {
  return (
    <header className="page-header resource-feature-header">
      <div>
        <a className="back-link" href={`/projects/${projectId}`}>← 返回项目总览</a>
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {description ? <p className="lede">{description}</p> : null}
      </div>
      {actions ? <div className="header-actions">{actions}</div> : null}
    </header>
  );
}
